module.exports = __webpack_public_path__ + "423c02479d090d9f7a4463e555e31678.svg";